<footer class="footer">
  <div class="inner">
    <span class="brand">Wesele Live</span>
    <div class="links">
      <a routerLink="/polityka-prywatnosci">Polityka prywatności</a>
      <a routerLink="/regulamin">Regulamin</a>
    </div>
    <span class="copy">© 2026 Wesele Live</span>
  </div>
</footer>
